// Dependencies
import React from 'react';

// Components
import Container from '../container/container';

// Styles
import JsNoticeStyles from './jsNotice.styles';

export default function JsNotice() {
  return (
    <JsNoticeStyles>
      <Container flex alignItems="center" justifyContent="center">
        <h6 className="heading">
          This site relies on JavaScript, please enable it for the best
          experience possible.
        </h6>
      </Container>
    </JsNoticeStyles>
  );
}
